export default __webpack_public_path__ + "static/cklass_logo-99c5bc67b9f428d5b4895a7f5685da5d.svg";